import { EntityId } from '@factorialco/f0-react/dist/experimental'

// Type conversion helpers for workflow values
/**
 * Converts the value coming from any Input (String, Number, null) to a string
 * Number values will not be localized
 */
export const convertToWorkflowValue = (value: string | number | null): string => {
  if (value === null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number') return value.toString() //for numbers will always use dot (.) for decimal separator
  return ''
}
/**
 * Converts the value coming from workflow expression (String) to an EntityId
 */
export const convertEntityFromWorkflowValue = (stringValue: string): EntityId | null => {
  if (!stringValue) return null
  const asNumber = parseInt(stringValue, 10)
  return isNaN(asNumber) ? stringValue : asNumber
}

/**
 * Converts an array of EntityIds to a workflow JSON string for integer_array literals
 */
export const convertArrayToWorkflowValue = <T>(
  value: T | T[] | null,
  target: 'string' | 'number' = 'string'
): string => {
  if (!value || (Array.isArray(value) && value.length === 0)) return '[]'
  if (Array.isArray(value)) {
    // Ensure all values are integers
    if (target === 'number') {
      const intArray = value.map((v) => (typeof v === 'string' ? parseInt(v, 10) : v))
      return JSON.stringify(intArray)
    }
    return JSON.stringify(value)
  }
  return JSON.stringify([value])
}

/**
 * Converts a workflow JSON string (integer_array literal) to an array of EntityIds
 */
export const convertArrayFromWorkflowValue = <T>(stringValue?: string): T[] => {
  if (!stringValue || stringValue === '[]') return []
  try {
    const parsed = JSON.parse(stringValue)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
